export const download = {
  name: "download" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M22.4 21.5a.9.9 0 0 1-.9.9h-19a.9.9 0 0 1-.9-.9V11a.9.9 0 0 1 1.8 0v9.6h17.2V11a.9.9 0 0 1 1.8 0v10.5Zm-9.764-4.864a.9.9 0 0 1-1.272 0l-5-5a.9.9 0 0 1 1.272-1.272l3.464 3.463V2.5a.9.9 0 0 1 1.8 0v11.327l3.464-3.463a.9.9 0 0 1 1.272 1.272l-5 5Z" clip-rule="evenodd"/></svg>`,
  keywords: ["download"],
  category: "action" as const,
};
